import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * X (Twitter) OAuth callback handler
 * 
 * This component handles the redirect from X (Twitter) OAuth flow.
 * It extracts the authorization code from URL and sends it to the parent window.
 */
export default function TwitterCallback() {
  const [searchParams] = useSearchParams();
  
  useEffect(() => {
    // Extract authorization parameters from URL
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description');
    
    // Log for debugging
    console.log('X (Twitter) OAuth callback received', { code, state, error, errorDescription });
    
    // Check if we're in a popup window
    if (window.opener) {
      // Send message to parent window
      window.opener.postMessage({
        type: 'twitter_auth_callback',
        code,
        state,
        error,
        errorDescription
      }, window.location.origin);
      
      // Close the popup
      window.close();
    } else {
      // Handle case where we're not in a popup
      // This could happen if user opened the link directly
      console.error('X (Twitter) callback opened directly, not in popup window');
      document.body.innerHTML = `
        <div style="text-align:center; padding: 2rem;">
          <h1>X (Twitter) Authentication</h1>
          <p>${error ? 'Authentication failed: ' + errorDescription : 'Authentication successful'}</p>
          <p>You can close this window now and return to the application.</p>
        </div>
      `;
    }
  }, [searchParams]);
  
  return (
    <div className="flex flex-col items-center justify-center min-h-screen p-4">
      <h1 className="text-2xl font-bold mb-4">X (Twitter) Authentication</h1>
      <p className="text-center mb-4">
        Processing your authentication...
      </p>
      <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-gray-900"></div>
    </div>
  );
} 